import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useLevel1SectionData } from '../../hooks/useLevel1Section';

const generalSections = [
  'radio_turns_on',
  'interior_vehicle_odor',
  'keys',
  'air_conditioning',
  'heater',
  'interior_overall'
];

export const InteriorLevel3 = () => {
  const { subSections, images } = useLevel1SectionData('interior_questions');

  return (
    <Level2Wrapper flex="1 1 100%" label="Interior">
      <ImageList label="Interior Pictures" images={images.slice(1)} />
      {generalSections.map(sectionKey => {
        const section = subSections[sectionKey];
        if (!section || !section.grade) return null;
        return <GenericSubSection key={sectionKey} section={subSections[sectionKey]} />;
      })}
    </Level2Wrapper>
  );
};
